import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import CustomSpinner from './CustomSpinner';
import CustomAlert from '../components/CustomAlert.js';
import RenderField from './RenderField';
import AttributeOptions from './AttributeOptions';

require(`../assets/${process.env.PAGE}/css/components/deposit_form.css`);

class DepositForm extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount(){}

    render() {

        const { handleSubmit, submitting, error } = this.props;
        const deposit_types = [
            {id:0 , name:'Acreditación en caja de ahorro Montemar'},
            {id:1 , name:'Orden de pago por cajeros Link'},
            {id:2 , name:'Acreditación en caja de ahorro de otros bancos'},
        ]

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <div className="step_deposit">
                            <FormattedHTMLMessage id="app.step_deposit" description="Incomes info"/>
                        </div>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveDeposit)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="deposit_type" defaultValue="Modalidad del Depósito" label="Modalidad del Depósito" attributeName='deposit_type' attributeOptions={deposit_types}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

DepositForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'deposit_type', 'required':true}]);

DepositForm = TopScrolleable(DepositForm);

DepositForm = reduxForm({
    form: 'DepositForm', // a unique name for this form
    validate
})(DepositForm);

DepositForm = withAuthControl(DepositForm);

export default DepositForm;


/** WEBPACK FOOTER **
 ** ./src/components/DepositForm.js
 **/